import { Link, type LinkProps } from '@tanstack/react-router';
import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export type EmptyStateProps = {
  icon?: LucideIcon | undefined;
  title: string;
  description?: string | undefined;
  action?: { label: string; onClick?: () => void; to?: LinkProps } | undefined;
  /** Contenu libre sous l'action (bouton désactivé avec tooltip, par exemple). */
  children?: ReactNode;
  className?: string | undefined;
};

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  children,
  className,
}: EmptyStateProps) {
  return (
    <div
      data-slot="empty-state"
      className={cn('flex flex-col items-center justify-center gap-3 py-16 text-center', className)}
    >
      {Icon && <Icon className="size-8 text-muted-foreground" aria-hidden />}
      <p className="text-lg font-medium">{title}</p>
      {description && <p className="max-w-md text-sm text-muted-foreground">{description}</p>}
      {action &&
        (action.to ? (
          <Button asChild>
            <Link {...action.to}>{action.label}</Link>
          </Button>
        ) : (
          <Button onClick={action.onClick}>{action.label}</Button>
        ))}
      {children}
    </div>
  );
}
